var Handlebars = require('/data/wordpress/wp-content/themes/freepik-blog/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=helpers.helperMissing, alias3=container.escapeExpression;

  return "    <li class=\"countdown__"
    + alias3(((helper = (helper = helpers.key || (data && data.key)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"key","hash":{},"data":data}) : helper)))
    + "\">\n        <span class=\"countdown__value\">"
    + alias3(container.lambda(depth0, depth0))
    + "</span>\n        <span class=\"countdown__title\">"
    + alias3((helpers.index_of || (depth0 && depth0.index_of) || alias2).call(alias1,((stack1 = (data && data.root)) && stack1.language),(data && data.key),{"name":"index_of","hash":{},"data":data}))
    + "</span>\n    </li>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<ul>\n"
    + ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.date : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</ul>";
},"useData":true});